import { CommentService } from '@/api/comment';
import { OutlineButton } from '@/components/shared/button/OutlineButton';
import { Button, Dialog, Modal, ModalRef } from 'alurkerja-ui';
import React, { useRef } from 'react';
import { FaTrash } from 'react-icons/fa';

type DeleteCommentProps = {
  id: string;
  onSucces?: () => void;
};

export const DeleteComment: React.FC<DeleteCommentProps> = ({
  id,
  onSucces,
}) => {
  const ref = useRef<ModalRef>(null);
  const { mutate: deleteMutate, isPending: isDeleteLoading } =
    CommentService.useDelete();

  const deleteAction = (id: string) => {
    deleteMutate(id, {
      onSuccess: () => {
        Dialog.success({
          title: 'Success',
          description: 'Comment has been deleted',
          callback: onSucces,
        });
      },
      onError: () => {
        Dialog.error({
          title: 'Error',
          description: 'Failed to delete Comment',
        });
      },
    });
  };

  return (
    <Modal
      ref={ref}
      triggerButton={
        <Button className="bg-red-600">
          <FaTrash />
        </Button>
      }
      title="Delete Comment"
    >
      {({ closeModal }) => {
        return (
          <div className="flex flex-col gap-4 p-4">
            <p className="text-gray-500">
              Are you sure you want to delete this Comment? This action cannot
              be undone.
            </p>

            <div className="flex flex-row gap-2">
              <OutlineButton onClick={closeModal}>Cancel</OutlineButton>

              <Button
                type="button"
                color="red"
                onClick={() => deleteAction(id)}
                loading={isDeleteLoading}
              >
                Delete
              </Button>
            </div>
          </div>
        );
      }}
    </Modal>
  );
};
